import { z } from 'zod';
/**
 * Stable, machine-readable error codes. The frontend maps a code to a
 * translated message; it never parses the human-readable `message`.
 * Add codes, never repurpose them.
 */
export const ERROR_CODES = [
    'VALIDATION_FAILED',
    'USERNAME_TAKEN',
    'NO_PLATFORM_ACCESS',
    'UA_UNAVAILABLE',
    'UNAUTHENTICATED',
    'INVALID_CREDENTIALS',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'UNIQUE_VIOLATION',
    'FOREIGN_KEY_VIOLATION',
    'RATE_LIMITED',
    'IDEMPOTENCY_KEY_REUSED',
    'REQUEST_IN_PROGRESS',
    'PAYLOAD_TOO_LARGE',
    'UNPROCESSABLE',
    'INTERNAL_ERROR',
    'SERVICE_UNAVAILABLE',
    // tablet.md sections 2, 3 and 5: the platform, tablet and admin APIs.
    'SYSTEM_EXISTS',
    'IDEMPOTENCY_CONFLICT',
    'TABLET_NOT_AVAILABLE',
    'TABLET_BUSY',
    'TABLET_PAIRING_CODE_INVALID',
    'TABLET_UNAUTHENTICATED',
    'TABLET_INACTIVE',
    'TASK_CLOSED',
    'TASK_NOT_SUBMITTED',
    'SIGNATURE_REQUIRED',
    // tablet.md version 1.1: a used, cancelled or expired link (section 2.9).
    'LINK_INVALID',
    // Link tasks need TABLET_WEB_URL set to the tablet page's public address.
    'LINK_UNAVAILABLE',
];
export const errorCodeSchema = z.enum(ERROR_CODES);
export const fieldErrorSchema = z.object({
    path: z.string(),
    message: z.string(),
    code: z.string().optional(),
});
//# sourceMappingURL=api-error.js.map